import { Fill, RegularShape, Stroke, Style, Text } from 'ol/style';
import LayerConfig from './LayerConfig';
import CircleStyle from 'ol/style/Circle';

import EditionToolType from './EditionToolType';
import { Point } from 'ol/geom';
import MapService from '@/services/MapService';

export default class AnnotationLayerConfig extends LayerConfig {
  mapService!: MapService;
  constructor(input?: any) {
    super(input);
    if (input) {
      this.loadFromJson(input);
    }
  }

  getEditStyle(mapService:any): any {
    this.mapService = mapService;
    let retour = (feature: any, resolution: any) => {
      return this.getAnnotationStyleFunction().call(this, feature, resolution, true);
    };
    return retour;
  }

  isVector(): boolean {
    return true;
  }

  getStyleFunction(): any {
    return this.getAnnotationStyleFunction();
  }

  getAnnotationStyleFunction(): any {
    let retour: any = (feature: any, resolution: any, selection = false) => {

        
    let fillColor = feature.get('fillColor') ? feature.get('fillColor') : '#000000';
    let strokeWidth = feature.get('strokeWidth') ? parseInt(feature.get('strokeWidth'))  : 2;
    let strokeColor = feature.get('color') ? feature.get('color')  : '#115544';
    
    let symbolType = feature.get('type') ? feature.get('type')  : '';
    let symbolSize = feature.get('size') ? feature.get('size')  : 8;
    let symbolRotation = feature.get('rotation') ? feature.get('rotation')  : 0;
    let arrow = feature.get('arrow') ? feature.get('arrow')  : false;
    const style = new Style({
        stroke: new Stroke({
          color: /*selection ? '#ffcc33' :*/ strokeColor,
          width: strokeWidth,
          lineDash:selection ? [10,10,10,10] :[0],
          lineDashOffset:selection ? 4 :0,
        }),
        fill: new Fill({
          color: /*selection ? 'rgba(255, 255, 255, 0.3)' :*/ fillColor,
        }),
      });

      let color = 'rgba(15,15,15,0.3)';
      if (selection) {
        color = '#ffcc33';
        //strokeColor = '#ffcc33';
      }
      const symbolStyle = new CircleStyle({
        radius: symbolSize,
        stroke: new Stroke({
          color: '#115544',
          width: 1,
        }),
        fill: new Fill({
          color,
        }),
      });
      if (
        this.mapService.editionService &&
        this.mapService.editionService.activeTool == EditionToolType.UPDATE_SHAPE
      ) {
        style.setImage(symbolStyle);
      }
      if (symbolType == 'circle'){
        let s = new CircleStyle({
          radius: symbolSize / 2,
          stroke: new Stroke({
            color: strokeColor,
            width: 1,
          }),
          fill: new Fill({
            color: strokeColor,
          }),
        });
        style.setImage(s);
      }
      else if (symbolType == 'square'
      || symbolType == 'cross'
      || symbolType == 'triangle'
      || symbolType == 'star') {
        // default square values
        let points = 4;
        const radius = symbolSize / 2;
        let radius2;
        let angle = symbolRotation*Math.PI / 180 ;
        let rotation = 0;
        if (symbolType == 'cross') {
          points = 4;
          radius2 = 0;
          rotation = 0;
          angle += Math.PI/4;
        } else if (symbolType == 'triangle') {
          points = 3;
         // angle = 0;
        } else if (symbolType == 'star') {
          points = 5;
          radius2 = symbolSize / 4;
          rotation = 0;
          //angle = 0;
        }else if (symbolType == 'square') {
          angle += Math.PI/4;
        }

        const symbolStyle = new RegularShape({
          stroke: new Stroke({
            color: strokeColor,
            width: 1,
          }),
          fill: new Fill({
            color: strokeColor,
          }),
          points,
          radius,
          radius2,
          rotation,
          angle,
        });

        style.setImage(symbolStyle);
      }


      let fontFamily = feature.get('fontFamily') ? feature.get('fontFamily') : 'Arial';
      let textfillColor = feature.get('fontColor') ? feature.get('fontColor') : '#000000';
      let size = feature.get('fontSize');
      let rotation = feature.get('textRotation') ? feature.get('textRotation') : 0;
      rotation = rotation * Math.PI / 180;
      const font = `${size}px "${fontFamily}"`;
      const options: any = {
        textBaseline: 'bottom',
        font,
        text: feature.get('text'),
        fill: new Fill({ color: /*selection ? '#ffcc33' : */textfillColor }),
        //stroke: new Stroke({ color: outlineColor, width: outlineWidth }),
        rotation: rotation,
        offsetY: -15,
      };

      style.setText(new Text(options));

      var geometry = feature.getGeometry();
      let styles=[style];
      if(geometry.getType()=='LineString' && arrow){
        let start:any=[];
        let end:any=[];
        geometry.forEachSegment(function (startx:any, endx:any) {
          start=startx;
          end=endx;
        });

        var dx = end[0] - start[0];
        var dy = end[1] - start[1];
        var rotat = Math.atan2(dy, dx);

        styles.push(new Style({
          geometry: new Point(end),
          image: new RegularShape({
            fill: new Fill({color: strokeColor,}),
            points: 3,
            radius: strokeWidth*2+4,
            rotation: -rotat,
            angle: Math.PI / 2 // rotate 90°
          })
        }));



      }
     
      return styles;
    };
    return retour;
  }
}
